<template>
  <span
    class="result_toggle_item "
    :class="$store.state.slideActive.stopSubmission ? 'locked-state' : 'hover-item'"
  >
    <span

      :class="{'disabled': loading }"
      @click.stop="toggleSubmission()"
    >
      <span
        class="wrapper-submission"
        v-if="$store.state.slideActive.stopSubmission"
        v-tooltip="$i18nPresenter.t('Click to Unlock')"
      >
        <aha-icon
          width="20"
          height="20"
          name="lock-sub"

          viewBox="0 0 24 24"
        ></aha-icon>
        {{ $i18nPresenter.t('Submission locked') }}
      </span>
      <aha-icon
        v-else
        v-tooltip="hideSubmissionTooltip"
        name="lock-sub"
        viewBox="0 0 24 24"
      ></aha-icon>

    </span>
  </span>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import Socket from '@/socket'
import Config from '@/config'
import Util from '@/util'
import lock from '@/assets/animations/Lock.webm'
import unlock from '@/assets/animations/Unlock.webm'

const DEFAULT_TIME_CLOSE_TOOLTIP = 3000
export default {
  name: 'SubmissionToggleModal',
  data() {
    return {
      lock,
      unlock,
      loading: false,
      isDisplayRevealTooltip: false,
      hoverTooltipWhenLock: false,

    }
  },

  computed: {
    hideSubmissionTooltip() {
      if (this.hoverTooltipWhenLock) {
        return this.$i18nPresenter.t('Lock submission')
      }
      return {
        show: this.isDisplayRevealTooltip,
        content: this.isDisplayRevealTooltip ? this.$i18nPresenter.t('Submission unlocked') : '',
      }
    },
  },

  methods: {
    ...mapGetters(['isPresenting', 'isBackstage']),
    ...mapActions(['updateSlideActiveAction', 'setSyncLoadingAction']),
    toggleSubmission() {
      if (this.$store.state.slideActive.stopSubmission) {
        this.isDisplayRevealTooltip = true
        this.hoverTooltipWhenLock = false
      }
      this.$emit('hideFullScreen')
      const params = {
        accessCode: this.$store.state.presentation.uniqueAccessCode,
        socketId: Socket.getSocketId(),
      }
      params.stopSubmission = !this.$store.state.slideActive.stopSubmission
      this.updateSlideActiveAction({
        stopSubmission: params.stopSubmission,
      })
      if (!params.stopSubmission && this.$store.state.slideActive.timeToAnswer) {
        const stopSubmissionTime = new Date().getTime() +
            this.$store.state.slideActive.timeToAnswer * 1000
        this.updateSlideActiveAction({
          stopSubmissionTime,
        })
        params.stopSubmissionTime = stopSubmissionTime
        params.timeToAnswer = this.$store.state.slideActive.timeToAnswer
      }
      this.$store.dispatch('setSyncPresentation', 1)
      params.presenting = this.$store.getters.isPresenting
      this.$http
        .put(Config.api.updateSlide + this.$store.state.slideActive.id, params)
        .then(
          () => {
            Util.mixpanelTracking(
              'Slide',
              'Edit setting',
              'Presenter edit setting stop submission',
              this.$store.state.slideActive.stopSubmission,
            )

            this.$store.dispatch('setSyncPresentation', 2)
          },
          () => {
            this.$store.dispatch('setSyncPresentation', 3)
          },
        )
    },

  },
  watch: {
    isDisplayRevealTooltip() {
      if (this.isDisplayRevealTooltip) {
        setTimeout(() => {
          this.isDisplayRevealTooltip = false
          setTimeout(() => {
            this.hoverTooltipWhenLock = true
          }, 300)
        }, DEFAULT_TIME_CLOSE_TOOLTIP)
      }
    },
  },
}
</script>

<style lang="scss" scoped>

.disabled {
  opacity: 0.5;
  cursor: not-allowed;
  pointer-events: none;
}
.result_toggle_item {
  position: relative;
  cursor: pointer;
  margin-left: 22px;
  display: inline-block;
}
.locked-state {
  font-size: 14px;
  font-weight: 500;

  color: #fff;
  display: inline-block;
  vertical-align: middle;
  &:hover::before {
    background: rgba(37, 122, 220, 1);
  }
}
.locked-state::before {
  content: "";
  display: inline-block;
  height: 35px;
  position: absolute;
  top: -7.5px;
  left: -9px;
  z-index: -1;
  width: 114%;
  background: #348ef6;
  border-radius: 50px;
  transition: all 0.3s ease;

}
.hover-item {

  &:hover::after{
    opacity: 1;
  }
  &::after {
    content: "";
    position: absolute;
    opacity: 0;
    transition: all 0.3s ease;
    background: #ebebeb;
    z-index: -1;

    width: 36px;
    height: 36px;
    border-radius: 50%;
    top: -4px;
    left: -6px;
  }

}
  .wrapper-submission{
    display: flex;
    align-items: center;
    svg {
      margin-right: 8px;
    }
  }
.show-submission-modal {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 28;
  background: #fff;
  color: #333;
  border-radius: 8px;
  &.invisible {
    display: none;
  }
  .modal-content {
    transition: all 0.5s ease;
    width :150px;
    height: 90px;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid rgba(0, 0, 0, 0.05);
    box-shadow: 0px 8px 14px rgba(82, 95, 127, 0.13) !important;
  }

  .header {
    font-weight: bold;
    text-align: center;
    font-size: 1.3em;
  }
  .submission {
    color: #828282;
    margin-bottom: 16px !important;
  }
}

</style>
